module.exports = __webpack_public_path__ + "img/pet_camera_power.d45f6707.png";